<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-23 18:18:11
 * @LastEditors: error: git config user.email & please set dead value or install git
 * @LastEditTime: 2023-05-06 17:15:16
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-select.vue
 * @Description: 描述
 -->

<template>
  <div :title="text"
    widget-type="select">
    <a-select v-model="text"
      :size="size"
      :data-model="fieldName"
      :disabled="disabled"
      :placeholder="disabled ? '' : placeholder"
      :class="options.customClass"
      :allowClear="options.clearable"
      :mode="options.multiple ? 'multiple' : 'default'"
      :showSearch="options.filterable"
      optionFilterProp="children"
      :filterOption="filterOption"
      :dropdownMatchSelectWidth="false"
      option-label-prop="label"
      dropdownClassName="wg-select"
      @dropdownVisibleChange="handleFilterOptions"
      @search="fetchOptions"
      @change="handleChange">
      <template v-for="(item, index) in selectList">
        <template v-if="item.children">
          <a-select-opt-group :key="index">
            <span slot="label">{{ item.label || item.value }}</span>
            <a-select-option v-for="(option, idx) in item.children"
              :disabled="option.disabled || false"
              :value="option.value"
              :label="option.label || option.value"
              :key="idx">{{ option.label || option.value }}</a-select-option>
          </a-select-opt-group>
        </template>
        <template v-else>
          <a-select-option :disabled="item.disabled || false"
            :value="item.value"
            :label="item.label || item.value"
            :key="index">
            <template v-if="item.showType === 'user'">
              <div class="clearfix">
                <a-avatar :size="36"
                  :src="item.item.avatarUrl"></a-avatar>
                <div class="clearfix">
                  <div class="title">{{ item.item.accountName }}</div>
                  <div class="description">{{ item.item.deptName }}</div>
                </div>
              </div>
            </template>
            <template v-else>
              {{ item.label || item.value }}
            </template>
          </a-select-option>
        </template>
      </template>
    </a-select>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        defaultValue: '',
        multiple: false,
        disabled: false,
        clearable: true,
        placeholder: '',
        required: false,
        showLabel: false,
        width: '',
        options: [],
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        filterable: false,
        remoteOptions: [],
        children: 'children',
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
      },
      selectList: [],
      fetching: false,
      filterType: 'remote', //  过滤类型，包括 remote | local;
      filterOption: false,
      // 是否应过滤过选项集合
      hasFilter: false,
    };
  },
  mounted() {
    const { func } = this.separateFunc(this.options.remoteFunc);
    // 如果是以下数据，在本地搜索
    if (this.formContext) {
      if (this.formContext.selectLocalNames.indexOf(func) > -1) {
        this.filterType = 'local';
      }
    }
    if (this.options.filterable) {
      if (this.filterType === 'local') {
        this.filterOption = this.filterOptionFunc;
        this.initOptions();
      } else {
        this.fetchOptions = debounce(this.fetchOptions, 800);
      }
    } else {
      this.initOptions();
    }
  },
  methods: {
    initVal(val) {
      // 数据库返回的是字符串，如果是多选，则转化为数组给组件使用
      // this.text值在多选和单选时数据类型是不一样的，多选时必须是数组
      // 如果是多选且默认值不是数组，那么传递的值val是字符串，需要将其转换为数组，
      // 否则直接将val赋值给this.text; 单选val是数组的错误（可能性）不做处理
      if (this.widget.options.multiple && !Array.isArray(this.defaultValue)) {
        if (val) {
          this.text = val.split(',');
        } else {
          this.text = [];
        }
      } else {
        this.text = val || undefined;
      }
      // 可搜索，selectList 无选项时，且有val，需要先初始化选项
      if (this.options.filterable && this.selectList.length === 0 && val) {
        this.setOptions();
      }
    },
    // 将value翻译为text
    setOptions() {
      const value = this.text;
      if (value && value.length) {
        if (Array.isArray(value)) {
          this.fetchOptions(value.join(), true, {}, true);
        } else {
          this.fetchOptions(value, true, {}, true);
        }
      }
    },
    handleChange(val) {
      // const newVal = val || this.defaultValue;
      // 将数组转为字符串，数据库服务器存储字符串，因此需要将数组转为字符串
      let newVal;
      if (this.options.multiple && !Array.isArray(this.defaultValue)) {
        newVal = val.join();
      } else {
        newVal = val || this.defaultValue;
      }

      let selectedItems = [];
      const options = [];
      if (this.options.multiple) {
        this.selectList.forEach((item) => {
          if (item.children) {
            item.children.forEach((option) => {
              options.push(option);
            });
          } else {
            options.push(item);
          }
        });
        selectedItems = options.filter(item => newVal.split(',').includes(item.value)).map(opt => opt.item);
      } else {
        this.selectList.forEach((item) => {
          if (item.children) {
            item.children.forEach((option) => {
              options.push(option);
            });
          } else {
            options.push(item);
          }
        });
        if (options.find(item => item.value === newVal)) {
          selectedItems = [options.find(item => item.value === newVal).item];
        }
      }

      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'select',
          rowIndex,
          field,
          value: newVal,
          selectedItems,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal, { selectedItems });
    },
    initOptions(otherArgs = {}) {
      const {
        remote, remoteType, remoteOption, remoteFunc,
      } = this.options;
      const { func, args } = this.separateFunc(remoteFunc);
      if (remote) {
        if (remoteType === 'func' && this.remote[func]) {
          this.remote[func](
            (data) => {
              this.selectList = data.map(item => ({
                value: item[this.options.props.value],
                label: item[this.options.props.label],
                showType: item.showType,
                deleteFlag: item.deleteFlag,
                disabled: item.disabled || false,
                children: item[this.options.children],
                item: item.item || {},
              }));
              this.hasFilter = false;
            },
            { args, otherArgs },
          );
        } else if (remoteType === 'option' && this.dynamic[remoteOption]) {
          this.selectList = this.dynamic[remoteOption];
          this.hasFilter = false;
        }
      } else {
        this.selectList = this.options.options.map(item => ({
          ...item,
          item,
        }));
        this.hasFilter = false;
      }
    },

    fetchOptions(value, exact = false, otherArgs = {}, clearList = false) {
      // 本地搜索不执行函数
      if (this.filterType === 'local') {
        return;
      }
      this.options.options = [];
      this.fetching = true;
      const {
        remote, remoteType, remoteOption, remoteFunc,
      } = this.options;
      const { func, args } = this.separateFunc(remoteFunc);
      if (remote && remoteType === 'func' && this.remote[func]) {
        this.remote[func](
          (data) => {
            this.selectList = data.map(item => ({
              value: item[this.options.props.value],
              label: item[this.options.props.label],
              showType: item.showType,
              deleteFlag: item.deleteFlag,
              disabled: item.disabled || false,
              children: item[this.options.children],
              item: item.item || {},
            }));
            this.fetching = false;
            // 目的是给设置值翻译完成汉字以后，清楚list,为下一次change重新检索
            if (clearList) {
              setTimeout(() => {
                this.selectList = [];
              }, 500);
            }
          },
          { args, otherArgs },
          value,
          exact,
        );
      } else if (remote && remoteType === 'option' && this.dynamic[remoteOption]) {
        this.selectList = this.dynamic[remoteOption];
      } else {
        this.selectList = this.options.options;
      }
    },
    // 过滤选项
    filterOptionFunc(input, option) {
      return option.componentOptions.propsData.label.toLowerCase().indexOf(input.toLowerCase()) > -1;
    },

    /**
     * 过滤选项，删除已经不存在的字典项目
     */
    handleFilterOptions() {
      if (!this.hasFilter) {
        // deleteFlag: 0 启用；1：禁用；2：注销 移除掉注销数据
        this.selectList = this.selectList.filter(item => item.deleteFlag !== '2');
        this.hasFilter = true;
      }
    },
  },
};
</script>
